<p-panel>
    <div class="container-fluid gap-5">
        <header>
            <h4>Plan Abonado

                <div *ngIf="loadingData" style="
                    display: inline-block;
                    margin-right: 10px;
                    position: relative;
                    top: 3px;">
                    <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6"
                        animationDuration="1.5s">
                    </p-progressSpinner>
                </div>
            </h4>
        </header>
        <div class="row">
            <div class="col">
                <app-reactive-form-builder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
                    [form]="form.formFields" [serverUrl]="form.env.auxServerUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger" [previousData]="getModel()"
                    [request]="this.getType() === 1 ? this.tareasApi.planAbonado.PUT : this.tareasApi.planAbonado.POST"
                    [getRequest]="this.tareasApi.planAbonado.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>